<template>
  <div
    class="companies_follow-toggle icon absolute top-0 right-0 m-3 cursor-pointer"
    data-testid="follow-company-toggle"
    @click.stop.prevent="$emit('on-follow')"
  >
    <IconFollow v-if="!following" class="w-full h-full" />
    <IconFollowing v-else class="w-full h-full" />
  </div>
</template>

<script type="ts" setup>
defineProps({
  following: {
    type: Boolean,
    required: true,
  }
})

defineEmits(['on-follow'])
</script>

<style lang="stylus" scoped>
.icon
  width: 1.75rem
  height: 1.5rem
  > svg
    filter: drop-shadow(0 0 3px rgba(0, 0, 0, 0.2))
.companies_follow-toggle
  transition: .15s all linear
</style>
